module.exports = __webpack_public_path__ + "img/logo-floridapolitechnic.1f0790d6.svg";